// libs
import React, { useCallback } from 'react'

// components
import Feedback from 'src/components/feedback/feedback'
import Icon from 'src/components/forms/icon/icon'
import LoggedOutMenu from 'src/components/header/main/logged_out_menu/logged_out_menu'
import MapToggler from 'src/containers/map_toggler'
import MainMenu from 'src/containers/smart_components/main_menu/main_menu'
import ChatToggler from 'src/containers/topic_chat/chat_toggler'

// interfaces & constants
import { CLASS_PREFIX } from 'src/constants'

// helpers
import { textResources } from 'src/lang/de'
import { COLOR_TYPE_GRAY_TINT_9 } from '../../../utils/color'
import './header_main.scss'

const cls: string = CLASS_PREFIX + 'header-main'

interface IProps {
  enableMapToggler: boolean;
  enableChatToggler?: boolean;
  loggedInUserEmail?: string;
  loggedIn: boolean;
  pageTitle?: JSX.Element;
  showLogInModal: () => void;
  showRegistrationModal?: () => void;
}

const HeaderMain: React.FC<IProps> = ({
  enableChatToggler,
  enableMapToggler,
  loggedIn,
  loggedInUserEmail,
  pageTitle,
  showLogInModal,
  showRegistrationModal
}) => {
  const [showFeedbackModal, setShowFeedbackModal] = React.useState(false)

  const showFeedback = useCallback(() => {
    setShowFeedbackModal(true)
  }, [])

  const hideFeedback = useCallback(() => {
    setShowFeedbackModal(false)
  }, [])

  return (
    <>
      {showFeedbackModal && (
        <Feedback loggedInUserEmail={loggedInUserEmail} close={hideFeedback} />
      )}
      <div className={cls}>
        {loggedIn
          ? (
            <MainMenu popupPosition={'left'} />
          )
          : (
            <LoggedOutMenu
              onLogIn={showLogInModal}
              onRegistration={showRegistrationModal}
            />
          )}
        <div className={cls + '__title'}>{pageTitle}</div>
        <div className={cls + '__right-wrapper'}>
          {enableChatToggler && <ChatToggler />}
          <div className={cls + '__toggler'}>
            {enableMapToggler && <MapToggler />}
          </div>
          <div className={cls + '__actions'}>
            <div className={cls + '__feedback'}>
              <button
                className={cls + '__feedback-button'}
                onClick={showFeedback}
              >
                <Icon
                  size={24}
                  name="bullhorn"
                  description={textResources.shared.feedback}
                  color={COLOR_TYPE_GRAY_TINT_9}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HeaderMain
